import { productBadges, type ProductBadgeTone } from '@nhanho/shared'
import type { Product } from '@nhanho/shared'

/**
 * Mask nhãn ở **góc phải trên** của ảnh sản phẩm (HOT / MỚI / -x%).
 *
 * Danh sách nhãn và thứ tự lấy từ `productBadges()` trong `packages/shared` — `apps/web`
 * dùng đúng hàm đó cho `ProductCard`, nên admin xem trước cái gì thì web hiện đúng cái đó.
 * Màu là token (`bg-danger`, `bg-primary-700`, `bg-warning`), không hardcode.
 */
const TONE: Record<ProductBadgeTone, string> = {
  danger: 'bg-danger text-white',
  primary: 'bg-primary-700 text-white',
  warning: 'bg-warning text-white',
}

export function BadgeMask({
  product, size = 'sm',
}: { product: Pick<Product, 'isHot' | 'isNewArrival' | 'onSale' | 'discountPercent'>; size?: 'sm' | 'md' }) {
  const badges = productBadges(product)
  if (!badges.length) return null
  const cls = size === 'sm' ? 'px-1 text-[9px] leading-4' : 'px-1.5 text-2xs leading-5'
  return (
    <div className="pointer-events-none absolute right-0.5 top-0.5 flex flex-col items-end gap-0.5">
      {badges.map((b) => (
        <span key={b.key} className={`rounded-sm font-bold uppercase tracking-wide shadow ${TONE[b.tone]} ${cls}`}>
          {b.label}
        </span>
      ))}
    </div>
  )
}
